import http from '@/api/http';
import {AuditStudentResponse} from 'cuny-ttd';

export default async (studentId: string, term: string): Promise<{
    beforeTerm?: AuditStudentResponse;
    afterTerm?: AuditStudentResponse;
    errors?: string[];
    ttdProps?: Record<string, any>;
}> => {
    const endpoint = '/ttd/audit-student';

    const res = await http.post(endpoint, {
        student_id: studentId,
        term
    });
    const results = res.data.results;

    return results;
};
